
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HeroSection',
  props: {
    images: {
      type: Array as () => string[],
      default: () => [],
    },
    eyebrow: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    dates: {
      type: String,
      default: '',
    },
    linkTo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentSlide: 0,
      slideInterval: null as ReturnType<typeof setInterval> | null,
    };
  },
  watch: {
    images(newImages: string[]) {
      this.resetSlideshow(newImages);
    },
  },
  mounted() {
    this.resetSlideshow(this.images);
  },
  beforeUnmount() {
    if (this.slideInterval) clearInterval(this.slideInterval);
  },
  methods: {
    resetSlideshow(images: string[]) {
      if (this.slideInterval) clearInterval(this.slideInterval);
      this.currentSlide = 0;
      if (images.length > 1) {
        this.slideInterval = setInterval(() => {
          this.currentSlide = (this.currentSlide + 1) % images.length;
        }, 5000);
      }
    },
  },
});
